import * as React from "react";

import Card from '@mui/material/Card';
import { useEffect, useState } from 'react';
import { MapContainer, Popup, Marker, TileLayer } from "react-leaflet";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import {  Grid, Link, InputLabel, Select, MenuItem, FormControl } from "@mui/material";
import {
    Unstable_NumberInput as BaseNumberInput,
    NumberInputProps,
  } from '@mui/base/Unstable_NumberInput';
import { styled } from '@mui/system';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import AddHomeIcon from '@mui/icons-material/AddHome';
import HouseIcon from '@mui/icons-material/House';
import StraightenIcon from '@mui/icons-material/Straighten';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import BedIcon from '@mui/icons-material/Bed';
import EmailIcon from '@mui/icons-material/Email';
import BusinessIcon from '@mui/icons-material/Business';
import BathtubIcon from '@mui/icons-material/Bathtub';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
const OfferModal = ({ listing, onClose }) => {

    const [imageSrc, setImageSrc] = useState(null);
    const [monthlyMaintainenceReservation, setMonthlyMaintainenceReservation] = useState(0);
    const [monthlyVacancyReserve, setMonthlyVacancyReserve] = useState(0);
    const [monthlyUtilities, setMonthlyUtilities] = useState(0);
    const [iconsActive, setIconsActive] = useState('pill1');
    const [downPayment, setDownPayment] = useState(0);
    const [downPaymentPercentage, setDownPaymentPercentage] = useState(0);
    const [closingCostsPercentage, setClosingCostsPercentage] = useState(0);
    const [interestRate, setInterestRate] = useState(0);
    const [term, setTerm] = useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [purchasePrice, setPurchasePrice] = useState(listing.price);
    const handleIconsClick = (value) => {
      if (value === iconsActive) {
        return;
      }
  
      setIconsActive(value);
    };
    let  OneBedFMR = 1207  // let OneBedFMR = 1
    let TwoBedFMR = 1355 // let OneBedFMR = 1
    let ThreeBedFMR = 1781  // let OneBedFMR = 1
    let FourBedFMR = 2086  // let OneBedFMR = 1
    let EfficiencyFMR = 1105  // let OneBedFMR = 1
   
    let fmr = 0
  

    console.log("LISTING-------_>", listing)


    const splitAddress = (address) => {
      const addressStr = String(address);
      const regex = /^(.*?),\s*(.*)$/;
      const match = addressStr.match(regex);
  
      return match ? { address1: match[1], address2: match[2] } : null;
    };
  
    const fetchPropertyData = async (address1, address2) => {
      const url =
        "https://api.gateway.attomdata.com/propertyapi/v1.0.0/property/basicprofile";
      const params = new URLSearchParams({ address1, address2 });
  
      setLoading(true);
      setError(null);
  
      try {
        const response = await fetch(`${url}?${params.toString()}`, {
          headers: {
            Accept: "application/json",
            APIKey: "b38c60f63ce05ed8f003d2388313f574", // Replace with actual API key
          },
        });
  
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
  
        const data = await response.json();
  
        // Extract FIPS and APN
        if (data.property && data.property.length > 0) {
          const fips = data.property[0].identifier.fips;
          const apn = data.property[0].identifier.apn.replace(/\D/g, ""); // Remove non-numeric chars
  
          // Redirect to Zillow link
          window.location.href = `https://www.zillow.com/CountyAssessorPage.htm?COUNTY_ID=${fips}&FORCE_GENERIC=false&LINK_LOCATION=TaxHistory&PARCEL_NUM=${apn}`;
        } else {
          throw new Error("Property data not found.");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
  
    const handleButtonClick = () => {
      const addressParts = splitAddress(listing.formattedAddress);
      if (!addressParts) {
        setError("Invalid address format");
        return;
      }
      fetchPropertyData(addressParts.address1, addressParts.address2);
    };


    const pillContainer = {
        
        
            gap: '20px 10px',
            marginTop: '35px',
            width: '100%',

            
            alignItems: 'center'
    }
    const pillContainer3 = {
        
        
            gap: '20px 10px',
            marginTop: '35px',
            width: '100%',

            
            alignItems: 'center'
    }
    const pillContainer2 = {
        
        
            gap: '20px 10px',
            marginTop: '35px',
            width: '100%',

            
            alignItems: 'center'
    }
    const data = [
        { label: "Tab 1", bgcolor: "#ffcccb" },
        { label: "Tab 2", bgcolor: "#b0e57c" },
        { label: "Tab 3", bgcolor: "#87ceeb", icon: "📌" },
      ];
    
    if (listing.bedrooms === 1) {
  fmr  = OneBedFMR
  
  }
    if (listing.bedrooms === 2) {
  fmr  = TwoBedFMR
  
  }
    if (listing.bedrooms === 3) {
  fmr  = ThreeBedFMR
  
  }
    if (listing.bedrooms > 3) {
  fmr  = FourBedFMR
  
  }

  var M; //monthly mortgage payment
    var P = (purchasePrice * .8); //principle / initial amount borrowed
    var I = 6.5 / 100 / 12; //monthly interest rate
    var N = 30 * 12; //number of payments months  

    function monthlyPayment(p, n, i) {
      return p * i * (Math.pow(1 + i, n)) / (Math.pow(1 + i, n) - 1);
    }

    M = monthlyPayment(P, N, I);
    

  var calculatedM; //monthly mortgage payment
    var calculatedP = (purchasePrice * (1-(downPaymentPercentage*.01))); //principle / initial amount borrowed
    var calculatedI = interestRate / 100 / 12; //monthly interest rate
    var calculatedN = term * 12; //number of payments months  

    function calculatedMonthlyPayment(calculatedp, calculatedn, calculatedi) {
      return calculatedp * calculatedi * (Math.pow(1 + calculatedi, calculatedn)) / (Math.pow(1 + calculatedi, calculatedn) - 1);
    }

    calculatedM = Math.round(calculatedMonthlyPayment(calculatedP, calculatedN, calculatedI));

const StyledInputRoot = styled('div')(
    ({ theme }) => `
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 400;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[500]};
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
  `,
  );
  
  const StyledInput = styled('input')(
    ({ theme }) => `
    font-size: 0.875rem;
    font-family: inherit;
    font-weight: 400;
    line-height: 1.375;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    box-shadow: 0 2px 4px ${
      theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
    };
    border-radius: 8px;
    margin: 0 8px;
    padding: 10px 12px;
    outline: 0;
    min-width: 0;
    width: 4rem;
    text-align: center;
  
    &:hover {
      border-color: ${blue[400]};
    }
  
    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[700] : blue[200]};
    }
  
    &:focus-visible {
      outline: 0;
    }
  `,
  );
  
  
  
  const StyledButton = styled('button')(
    ({ theme }) => `
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    box-sizing: border-box;
    line-height: 1.5;
    border: 1px solid;
    border-radius: 999px;
    border-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
    background: ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};
    color: ${theme.palette.mode === 'dark' ? grey[200] : grey[900]};
    width: 32px;
    height: 32px;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 120ms;
  
    &:hover {
      cursor: pointer;
      background: ${theme.palette.mode === 'dark' ? blue[700] : blue[500]};
      border-color: ${theme.palette.mode === 'dark' ? blue[500] : blue[400]};
      color: ${grey[50]};
    }
  
    &:focus-visible {
      outline: 0;
    }
  
    &.increment {
      order: 1;
    }
  `,
  );

    console.log(listing)

    let propertyTaxOperatingCost = Math.round(purchasePrice * .000925)
  let insuranceOperatingCost = Math.round(purchasePrice * .000833)


  ///////////PROPERTY TAXES///////////////////

/////////////PROPERTY MANAGEMENT//////////


// const totalPropManagement = currentRent *.1
const potentialTotalPropManagement = fmr *.1


//   let totalMonthlyExpense = (totalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation+Math.round(monthlyPayment(P,N,I)))
   let potentialTotalMonthlyExpense = (potentialTotalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation+Math.round(monthlyPayment(P,N,I)))
const NumberInput = React.forwardRef(function CustomNumberInput(
    props,ref
  ) {
    return (
      <BaseNumberInput
        slots={{
          root: StyledInputRoot,
          input: StyledInput,
          incrementButton: StyledButton,
          decrementButton: StyledButton,
        }}
        slotProps={{
          incrementButton: {
            children: <AddIcon fontSize="small" />,
            className: 'increment',
          },
          decrementButton: {
            children: <RemoveIcon fontSize="small" />,
          },
        }}
        {...props}
        ref={ref}
      />
    );
  });

  const blue = {
    100: '#daecff',
    200: '#b6daff',
    300: '#66b2ff',
    400: '#3399ff',
    500: '#007fff',
    600: '#0072e5',
    700: '#0059B2',
    800: '#004c99',
  };
  
  const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
  };
  
  const handleOverlayClick = (e) => {
    // Check if the click target is the overlay (not the modal content itself)
    if (e.target.className === "modal-overlay") {
      onClose();
    }
  };

  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };
  
const modalStyle = {
    position: "fixed", // Change to fixed for proper centering
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  zIndex: 1000, // Ensure it sits above all other elements
  marginTop: "30px",
  marginBottom: "30px",
  borderRadius: 3,
  width: "1100px",
  backgroundColor: "white", // Update `bgcolor` for clarity
  border: "2px solid #000",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)", // Slight shadow for style
  maxHeight: "100vh",
  padding: "16px", // Adjust padding for content spacing
  overflowY: "auto", // Enabl
  };

    useEffect(() => {
    const fetchImage = async () => {
        try {
          const timestamp = new Date().getTime();
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/streetview?size=600x300&location=${listing.latitude},${listing.longitude}&key=AIzaSyDVTNByoOWDFyw4OS55EaOzJ6yzpxYjKi8&timestamp=${timestamp}`
      );
    
          if (!response.ok) {
            throw new Error("Failed to fetch image");
          }
    
          // Convert response to a Blob
          const imageBlob = await response.blob();
    
          // Create a URL for the Blob
          const imageObjectURL = URL.createObjectURL(imageBlob);
    
          // Set the image URL in state
          setImageSrc(imageObjectURL);
        } catch (error) {
          console.error("Error fetching the image:", error);
        }
      };
      fetchImage()
    }, []);


    return ( <div
        className="modal-overlay"
        onClick={handleOverlayClick}
        style={overlayStyle}
      >
        <Box sx={modalStyle}>
<div style={{  marginRight: 0, display: 'flex' , justifyContent:'right', marginTop:'-13px'}} >

<button onClick={onClose} >
X
</button>
</div>
          {/* <h2>{listing.name}</h2>
          <p>ID: {listing.id}</p>
          <p>Description: {listing.description}</p> */}
          <Card sx={{ width: 1030, backgroundColor:'white', marginBottom:'20px', paddingBottom:'20px', borderRadius:'20px' }}>
          <p className="offer__title5">
            {listing.formattedAddress}
              
              
            </p>



            <div class="grid-container-element">
    <div class="grid-child-element purple"> <img src={imageSrc} width={800} height={100}></img></div>
    <div class="grid-child-element green">
    <div className="house-info__details-map">
            <MapContainer
                center={[listing.latitude, listing.longitude]}
                // center={["27.908595", "-82.460123"]}
              zoom={12}
              scrollWheelZoom={false}
              style={{ height: "100%", width: "110%",  }}
            >
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <Marker
                position={[listing.latitude, listing.longitude]}
              >
                <Popup>
                  A pretty CSS3 popup. <br /> Easily customizable.
                </Popup>
              </Marker>
            </MapContainer>
          </div>
    </div>
</div>  
            {/* <img src={imageSrc} width={1028} height={500}></img>

            */}
          

  <div className='bg-white'>
          <div className='bg-white'>
            
            
            
           
          
          <p className="offer__title5">
            ${purchasePrice} 

            
              
              
            </p> 
          <p >

            
              
              
            </p> 
            <div style={pillContainer2}>
                <div>
                        <div style={{
                            textAlign: 'center',
                            width: '250px',
                            marginRight:'10px',
                            float:'left',
                            padding:'5px'
                        }}>
                            <HouseIcon/> Year Built
                            <div>
                            {listing.yearBuilt}
                        </div>
                        
                        </div>
                        
                </div>
                <div>
                        <div style={{
                            textAlign: 'center',
                            
                            width: '250px',
                            marginRight:'10px',
                            float:'left',
                            padding:'5px'
                        }}>
                            <SquareFootIcon/>Lot SQFT
                            <div>
                            {listing.lotSize}
                        </div>
                            
                        </div>
                        
                </div>
                <div>
                        <div style={{
                            textAlign: 'center',
                           
                            width: '250px',
                            marginRight:'10px',
                            float:'left',
                            padding:'5px'
                        }}>
                            <BedIcon/>Bedrooms
                            <div>
                            {listing.bedrooms}
                        </div>
                            
                        </div>
                        
                </div>
                <div>

             <div style={{
               
                marginLeft:'10px',
                width: 'auto',
                padding:'5px',
                overflow:'hidden',
                textAlign: 'center',

                
            }}>
                <BathtubIcon/>Bathrooms
                <div>
                {listing.bathrooms}
                        </div>
                
             </div>
             </div>

             
            <div>
            


            

            </div>
            </div>
            <div style={pillContainer}>
                <div>
                        <div style={{
                            textAlign: 'center',
                            border:'2px solid',
                            borderRadius:'30px',
                            width: '250px',
                            marginRight:'10px',
                            float:'left',
                            padding:'5px'
                        }}>
                            Est Cashflow
                            <div>
                            ${Math.round(fmr - M - (fmr *.1))}
                        </div>
                            
                        </div>
                        
                </div>
                <div>
                        <div style={{
                            textAlign: 'center',
                            border:'2px solid',
                            borderRadius:'30px',
                            width: '250px',
                            marginRight:'10px',
                            float:'left',
                            padding:'5px'
                        }}>
                            FMR
                            <div>
                            ${fmr}
                        </div>
                            
                        </div>
                        
                </div>
                <div>
                        <div style={{
                            textAlign: 'center',
                            border:'2px solid',
                            borderRadius:'30px',
                            width: '250px',
                            marginRight:'10px',
                            float:'left',
                            padding:'5px'
                        }}>
                            Est Pmt
                            <div>
                            ${Math.round(M * 10) / 10}
                        </div>
                            
                        </div>
                        
                </div>
                <div>

             <div style={{
                border:'2px solid',
                borderRadius:'30px',
                marginLeft:'10px',
                width: 'auto',
                padding:'5px',
                overflow:'hidden',
                textAlign: 'center',

                
            }}>
                Est Mgmt
                <div>
                            ${Math.round((fmr *.1) * 10) / 10}
                        </div>
                
             </div>
             </div>

             
            <div>
              
            <p style={{ marginTop: "1rem" }}>
            
            </p>
            
         
            <p style={{ marginTop: "1rem" }}>


            
            </p>
            <p style={{ marginTop: "1rem" }}>


            
  </p>
            </div>
            </div>
            <div style={pillContainer3}>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", marginBottom:'30px' }}>
  <button
    onClick={handleButtonClick}
    style={{
      backgroundColor: "#0074e4",
      color: "white",
      padding: "10px 20px",
      borderRadius: "5px",
      border: "none",
      cursor: "pointer",
      fontWeight: "bold",
    }}
    disabled={loading}
  >
    {loading ? "Loading..." : "Find Assessor Info"}
  </button>
  </div>
                <div>
                        <div style={{
                            textAlign: 'center',
                            border:'2px solid',
                            borderRadius:'30px',
                            width: '400px',
                            marginLeft:'55px',
                            float:'left',
                            padding:'5px'
                        }}>
                            <b>Listing Agent </b>
                            <div style={{marginBottom:3}}>
                           <PersonOutlineIcon style={{marginTop:-3}}/> {listing.listingAgent.name}
                        </div>
                            <div>
                            <PhoneAndroidIcon style={{marginBottom:3}}/>{listing.listingAgent.phone}
                        </div>
                            <div>
                           <EmailIcon style={{marginBottom:3}}/> {listing.listingAgent.email}
                        </div>
                            
                        </div>
                        
                </div>
                
                <div>
                        <div style={{
                            textAlign: 'center',
                            border:'2px solid',
                            borderRadius:'30px',
                            width: '400px',
                            float:'left',
                            padding:'5px',
                            marginLeft:'124px'
                        }}>
<b>Listing Office </b>                            <div>
                           <BusinessIcon style={{marginBottom:3}}/> {listing.listingOffice.name}
                        </div>
                            <div>
                            <PhoneAndroidIcon style={{marginBottom:3}}/> {listing.listingOffice.phone}
                        </div>
                            <div>
                            <EmailIcon style={{marginBottom:3}}/>{listing.listingOffice.email}
                        </div>
                            
                        </div>
                        
                </div>
                <div>

            
             </div>

             
            <div>
              
            <p style={{ marginTop: "1rem" }}>
            
            </p>
            
         
            <p style={{ marginTop: "1rem" }}>


            
            </p>
            <p style={{ marginTop: "1rem" }}>


            
  </p>
            </div>
            </div>
  
            
            
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={6} align={'center'}>
            <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ fontWeight: 'bold', alignContent:'center'}}>
            Current Financials
            
          </Typography>
            </Grid>
            <Grid item xs={6} align={'center'}>
            <Typography id="modal-modal-title" sx={{ fontWeight: 'bold'}} variant="h6" component="h2">
            Cashflow Calculation
           
          </Typography>
          
            </Grid>
            </Grid>
            <Grid container columns={2} >  
            <Grid container columns={2} xs={1} sx={{ border: 1, borderRadius:'5px', marginTop:'10px', padding:2}}>
            <Grid item xs={1}>
            <Typography id="modal-modal-title"  variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Prop Mgmt</h3>
              <h3 align={'center'}>${Math.round(fmr*.1)}</h3>
              {/* <h3 align={'center'}>$100</h3> */}
  
          </Typography>
            <Typography 
              id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Prop Taxes</h3>
              <h3 align={'center'}>${Math.round(purchasePrice * .000925)}</h3>

          </Typography>
            </Grid>
            <Grid item xs={1} sx={{borderBottom:'1px'}}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}} >Gross Rent</h3>
              <h3 align={'center'}>${fmr}</h3>
              {/* <h3 align={'center'} style={{fontWeight:'bold'}}>Prop Taxes</h3>
              <h3 align={'center'}>${(purchasePrice * .000925)}</h3> */}
              
          </Typography>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Total Op. Expenses</h3>
              <div align={'center'} >${(potentialTotalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation).toFixed(2)}</div>

          </Typography>
            </Grid>
            <Grid item xs={1}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Insurance</h3>
              <h3 align={'center'}>${Math.round(purchasePrice* .000833)}</h3>
              
          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
            <h3 align={'center'} style={{fontWeight:'bold'}}>Utilities</h3>
              <NumberInput aria-label="Quantity Input"  style={{marginBottom:'10px'}} min={1} max={100000}   value={monthlyUtilities}
    onChange={(event, val) => setMonthlyUtilities(val)}/>
          </Typography>
            </Grid>

            <Grid item xs={1}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Monthly NOI</h3>
              <div align={'center'} >${fmr - (potentialTotalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation) }</div>
              {/* <div align={'center'} >$ </div> */}
              
          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Annual NOI</h3>
              <div align={'center'} >${Math.round((fmr - (potentialTotalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation)) * 12) }</div>

          </Typography>
            </Grid>
            <Grid item xs={1}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Vacancy Reserve</h3>
              <NumberInput style={{marginBottom:'10px'}}aria-label="Quantity Input" min={1} max={100000}   value={monthlyVacancyReserve}
    onChange={(event, val) => setMonthlyVacancyReserve(val)}

/>              
          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Mtc Reserve</h3>
              <NumberInput style={{marginBottom:'10px'}} aria-label="Quantity Input" min={1} max={100000}   value={monthlyMaintainenceReservation}
    onChange={(event, val) => setMonthlyMaintainenceReservation(val)}

/>
          </Typography>
            </Grid>
            <Grid item xs={1}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Cap Rate</h3>
              <div align={'center'} >{((((fmr - (potentialTotalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation))*12)/purchasePrice)*100).toFixed(2)}%</div>

          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold', marginTop:'16px'}}>Mortgage</h3>
              {/* <div align={'center'} >${Math.round(monthlyPayment(P,N,I))}</div> */}
              <div align={'center'} >${Math.round(M)}</div>


          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold', marginTop:'16px'}}>Monthly Cashflow</h3>
              <div align={'center'} >${Math.round(fmr - potentialTotalMonthlyExpense)}</div>

          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold', marginTop:'16px'}}>Annual Cashflow</h3>
              {/* <div align={'center'} >${(currentRent - totalMonthlyExpense)*12}</div> */}
              <div align={'center'} >${Math.round((fmr - potentialTotalMonthlyExpense)*12)}</div>

          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold', marginTop:'16px'}}>Annualized ROI</h3>
              <div align={'center'} >{(100*(((fmr - potentialTotalMonthlyExpense)*12)/purchasePrice)).toFixed(2)}%</div>

          </Typography>







            </Grid>
            </Grid>
            <Grid container columns={2} xs={1} sx={{ border: 1, borderRadius:'5px', marginTop:'10px', padding:2, marginLeft:'0px'}}>
  
  <Grid item xs={1}>
            <Typography id="modal-modal-title"  variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}} >Down Payment %</h3>
              <NumberInput style={{marginBottom:'10px'}}aria-label="Quantity Input" min={1} max={100000}   value={downPaymentPercentage}
    onChange={(event, val) => setDownPaymentPercentage(val)}

/>              
  
          </Typography>
            <Typography 
              id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Closing Cost %</h3>
              <NumberInput style={{marginBottom:'10px'}}aria-label="Quantity Input" min={1} max={100000}   value={closingCostsPercentage}
    onChange={(event, val) => setClosingCostsPercentage(val)}

/>              

          </Typography>
            
            </Grid>
            <Grid item xs={1} sx={{borderBottom:'1px'}}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}} >Down Payment</h3>
              <h3 align={'center'}>${Math.round(purchasePrice * (downPaymentPercentage*.01))}</h3>
             
              
          </Typography>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold', marginTop:'14px'}}>Closing Costs</h3>
              <div align={'center'} >${Math.round(purchasePrice * (closingCostsPercentage*.01))}</div>
              {/* <h3 align={'center'}>$</h3> */}

          </Typography>
            </Grid>
            <Grid item xs={1}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Interest Rate %</h3>
              <NumberInput style={{marginBottom:'10px'}}aria-label="Quantity Input" min={1} max={100000}   value={interestRate}
    onChange={(event, val) => setInterestRate(val)}

/>              
              
          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
            <h3 align={'center'} style={{fontWeight:'bold'}}>Purchase Price</h3>
            {/* <h3 align={'center'}>${listing.price }</h3> */}
            <NumberInput style={{marginBottom:'10px'}}aria-label="Quantity Input" min={1} max={100000}   value={purchasePrice}
    onChange={(event, val) => setPurchasePrice(val)} />


          </Typography>
            </Grid>

            <Grid item xs={1}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Term (yrs)</h3>
              {/* <div align={'center'} >${marketRent - (potentialTotalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation) }</div> */}
              <NumberInput style={{marginBottom:'10px'}}aria-label="Quantity Input" min={1} max={100000}   value={term}
    onChange={(event, val) => setTerm(val)}

/>             

          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>LTV</h3>
              {/* <div align={'center'} >${(marketRent - (potentialTotalPropManagement+propertyTaxOperatingCost+insuranceOperatingCost+monthlyUtilities+monthlyVacancyReserve+monthlyMaintainenceReservation))*12}</div> */}
              <h3 align={'center'}>{100-downPaymentPercentage}%</h3>

          </Typography>
            </Grid>
<Grid item xs={1}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Principal</h3>
              <h3 align={'center'}>${purchasePrice- ( Math.round(purchasePrice * (downPaymentPercentage*.01))) }</h3>

              
          </Typography>
           
            </Grid>
            <Grid item xs={1}>
            <Typography  id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold'}}>Mortgage Payment</h3>
              <h3 align={'center'} >${calculatedM}</h3>
              
          </Typography>
            
          <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold', marginTop:'16px'}}>Monthly Cashflow</h3>
              <div align={'center'} >${Math.round(fmr - potentialTotalMonthlyExpense)}</div>

          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold', marginTop:'16px'}}>Annual Cashflow</h3>
              {/* <div align={'center'} >${(currentRent - totalMonthlyExpense)*12}</div> */}
              <div align={'center'} >${Math.round((fmr - potentialTotalMonthlyExpense)*12)}</div>

          </Typography>
            <Typography id="modal-modal-title" variant="h6" component="h2" >
              <h3 align={'center'} style={{fontWeight:'bold', marginTop:'16px'}}>Annualized ROI</h3>
              <div align={'center'} >{(100*(((fmr - potentialTotalMonthlyExpense)*12)/purchasePrice)).toFixed(2)}%</div>

          </Typography>
            </Grid>






            </Grid>

</Grid>

            
          </div>
         
        </div>
        
        </Card>
          {/* Add other listing details as needed */}
          {/* {/* <button onClick={onClose}>Close</button> */}
          <div style={{  marginTop: 20, marginRight: 0, display: 'flex' , justifyContent:'center'}} >

          <button onClick={onClose} class="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded">
  Close
</button>
</div>
          </Box>
        </div>
      
    );
  };
  
  export default OfferModal

